import React, { type PropsWithChildren } from 'react';

import type { ExtensionParams, Parameters } from '@atlaskit/editor-common/extensions';

import { NoExtensionData } from '@atlassian/company-hub-common';

import { ExperienceTimeout } from '@confluence/experience-tracker';
import {
	MacroExperienceStart,
	getMacroAttributesFromADFNode,
	EDITOR,
	getExperienceName,
} from '@confluence/macro-tracker';

export type CustomSitesExtensionProps<T extends Parameters> = {
	extensionNode: ExtensionParams<T>;
	contentId: string;
};

export const CustomSitesExtension = <T extends Parameters>({
	extensionNode,
	contentId,
	showNoDataState,
	children,
}: PropsWithChildren<CustomSitesExtensionProps<T> & { showNoDataState: boolean }>) => {
	const { extensionKey } = extensionNode;
	const macroAttributes = getMacroAttributesFromADFNode(extensionNode);

	return (
		<>
			<MacroExperienceStart
				name={getExperienceName(EDITOR, extensionNode)}
				contentId={contentId}
				mode={EDITOR}
				extensionKey={extensionKey}
				attributes={macroAttributes}
				timeout={ExperienceTimeout.MACRO_LOAD}
			/>
			{!showNoDataState ? children : <NoExtensionData source={extensionKey} />}
		</>
	);
};
